import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, {
  type WorkspaceAgentContextAddedMethod,
  type WorkspaceAgentContextAddedType,
} from './useTrackAgentContextAdded.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type {
  WorkspaceAgentContextAddedMethod,
  WorkspaceAgentContextAddedType,
} from './useTrackAgentContextAdded.meta';

export type UseTrackAgentContextAddedParams = {
  method: WorkspaceAgentContextAddedMethod;
  type: WorkspaceAgentContextAddedType;
};

export const useTrackAgentContextAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentContextAdded = useCallback(
    (params: UseTrackAgentContextAddedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentContextAdded };
};
